import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import spartaTemplates from "modules/home-loans/services-home-loans-module/2.2.0/js/templates";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";
export default keyMirror({

  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE: null,

  HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE: null,

  HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT: null,
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE: null,

  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT: null,

  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS: null,
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE: null,

  HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS: null,

  HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT: null,

  HOME_LOANS_ZIP_CODE_CHANGE_SUBMIT: null,

  HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS: null,
  HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE: null,

  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUBMITTED: null,

  HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT: null,

  HOME_LOANS_GENERIC_SUCCESS: null,

  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUBMIT: null,
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE: null,

  HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS: null,
  HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE: null,

  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUBMIT: null,
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE: null

});

/**
 * @method keyMirror
 * @param {Object} obj
 */
function keyMirror ( obj ) {

  var key;
  var ret = {};

  if ( !(obj instanceof Object && !Array.isArray(obj)) ) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }

  for ( key in obj ) {

    if (obj.hasOwnProperty(key)) {
      ret[key] = key;
    }

  }

  return ret;

}
